










































































  import { Component, Prop, mixins } from 'nuxt-property-decorator'
  import { namespace } from 'vuex-class'
  import { Currency, Products } from '@one/types'
  import uuid from 'uuid-random'
  import UtilsMixin from '../../../mixins/UtilsMixin'
  import { ProductItem } from '~/plugins/gtm/gtm'

  const stocks = namespace('stocks')

  @Component
  export default class OneProductOverview extends mixins(UtilsMixin) {
    @stocks.Getter isEnoughProductWithBlockLabelInStock: any
    mainComponentClass: string = 'one-product-overview'
    qtyInputValue: number | null = null
    qtyError: boolean = false
    active: boolean = false
    productUUID: string = uuid()

    @Prop({
      required: true,
      type: Object,
    })
    readonly product!: Products.Product

    @Prop({
      required: false,
      type: Number,
    })
    readonly initialInputValue?: number

    @Prop({
      type: String,
    })
    readonly productImg?: string

    @Prop({
      type: Number,
    })
    readonly quantity?: number | null

    @Prop({
      required: true,
      type: String,
    })
    readonly unit!: string

    @Prop({
      type: Boolean,
      default: true,
    })
    readonly showPurchaseOptions!: boolean

    @Prop({
      required: false,
      default: 'https://static-demo-images.s3-eu-west-1.amazonaws.com/photo_plcs_min.svg',
      type: String,
    })
    readonly placeholderImg!: string

    @Prop({
      required: true,
      type: Object,
    })
    readonly currency!: Currency

    @Prop({
      required: false,
      type: Object,
    })
    readonly price?: any

    @Prop({
      type: String,
    })
    where?: string

    mounted() {
      this.$plugins.onMounted(this.mainComponentClass, this, {
        product: this.product,
      })
    }

    destroyed() {
      this.$plugins.onUnmounted(this.mainComponentClass)
    }

    get truncName(): string {
      const { name } = this.product
      return name.length > 80 ? `${this.product.name.slice(0, 80)}...` : name
    }

    get productPhoto(): string {
      return this.productImg || this.placeholderImg
    }

    get productAlt(): string {
      return this.product?.photos[0]?.alt || this.product?.name
    }

    get enoughProduct(): boolean {
      const product = this.product

      return (
        product &&
        this.isEnoughProductWithBlockLabelInStock(this.qtyInputValue, product.labels, product.id)
      )
    }

    onProductClick(product) {
      this.$gtm.selectItem({
        item_id: product.id,
        item_name: product.name,
        item_brand: (product.brand && product.brand.name),
        category: this.$routes.getCategoryPath(product.canonicalCategory) || '',
        price: this.price?.price || 0,
        discount: this.price?.catalogPrice - this.price?.price,
      } as ProductItem, this.where)
    }

    isQtyError(e: boolean) {
      this.qtyError = e
    }

    changeValue(event: number) {
      this.qtyInputValue = Math.abs(event)
    }

    onAddToCart() {
      if (!this.qtyError) {
        this.$emit('add-to-cart', {
          productId: this.product.id,
          amountOfProducts: this.qtyInputValue
            ? this.qtyInputValue
            : this.product.measurementUnits.quantityMin,
        })
      }
    }

    onAddToWishlist() {
      if (!this.qtyError) {
        this.$emit('add-to-wishlist', {
          productId: this.product.id,
          amountOfProducts: this.qtyInputValue
            ? this.qtyInputValue
            : this.product.measurementUnits.quantityMin,
        })
      }
    }

    hoverOn() {
      if (this.$mq === 'xs') {
        return
      }
      this.active = true
    }

    hoverOff() {
      this.active = false
    }
  }
